import { render, staticRenderFns } from "./CardInfoChip.vue?vue&type=template&id=3ca964ae"
import script from "./CardInfoChip.vue?vue&type=script&lang=ts"
export * from "./CardInfoChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ca964ae')) {
      api.createRecord('3ca964ae', component.options)
    } else {
      api.reload('3ca964ae', component.options)
    }
    module.hot.accept("./CardInfoChip.vue?vue&type=template&id=3ca964ae", function () {
      api.rerender('3ca964ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardInfoChip.vue"
export default component.exports